import { FC, useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./Modal.scss";

interface ModalProps {
    show: boolean,
    header: string,
    description: string, 
    onCloseModal: () => void
}

export const Modal: FC<ModalProps> = (props: ModalProps) => {
    
    const [showModal, setShowModal] = useState(props.show);

    useEffect(() => {
        setShowModal(props.show);
    }, [props.show])

    return (showModal) ? <div className="modal">
        <div className="modal-bg" onClick={() => props.onCloseModal() }></div>  
        <div className="modal-wrapper">
            <button className="modal-close" onClick={() => props.onCloseModal() }>
                <FontAwesomeIcon icon={["fas", "close"]} />
            </button>
            <div className="modal-header">
                <h1>{props.header}</h1>
            </div>
            <div className="modal-content" dangerouslySetInnerHTML={{__html: props.description}}>
                {/* {props.description} */}
            </div>
        </div>
    </div> : null
}